import { BrowserRouter, Routes, Route } from "react-router"
import { Course } from "../Course/Course"
import { Demo } from "../Demo/Demo"
import { SiteIntro } from "./SiteIntro"
import { useEffect, useState } from "react"
import './Project.scss'
import { useIsLoggedIn, useProjectStore } from "./ProjectStore"
import { ProjectState } from "./ProjectState"

export function Project(){ 
    const loggedIn:boolean = useIsLoggedIn()

    function handleWindowSizeChange() {
        //setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = window.innerWidth <= 900;
    const className:string = (isMobile) ? 'mobile' : ''
    return(
        <div className={className}>
            <BrowserRouter>
                <Routes>
                    <Route path="*" element={(loggedIn) ? <Course /> : <SiteIntro />} />
                </Routes>
            </BrowserRouter>
        </div>
    )
}